import * as React from 'react';
import { makeStyles, shorthands, Spinner, Text, tokens } from '@fluentui/react-components';
import { VideoClipRegular } from '@fluentui/react-icons';
import { TextLink } from '@foundershub/components';
import { api } from './api';

interface Props {
  url: string;
  loadingText: string;
  isRounded?: boolean;
}

export function Oembed({ url, loadingText, isRounded }: Props) {
  const { data, isLoading } = api.useGetOembedQuery(url);
  const classes = useStyles();

  return isLoading ? (
    <Spinner aria-label={loadingText} />
  ) : data ? (
    <div className={classes.root}>
      <div className={isRounded ? classes.video : undefined} dangerouslySetInnerHTML={{ __html: data }} />
    </div>
  ) : url.length ? (
    <Text className={classes.empty}>
      <VideoClipRegular /> <TextLink href={url}>{url}</TextLink>
    </Text>
  ) : null;
}

const useStyles = makeStyles({
  root: {
    // nb: these styles work in conjunction with injected styles into the iframes returned
    // by the oembed providers to attempt to scale iframes to 16:9
    position: 'relative',
    // eslint-disable-next-line @foundershub/fluent
    paddingBottom: '56.25%',
    height: 0,
  },
  empty: {
    display: 'inline-flex',
    flexDirection: 'row',
    columnGap: tokens.spacingVerticalS,
    alignItems: 'center',
  },
  video: {
    '> iframe': {
      ...shorthands.borderRadius(tokens.spacingHorizontalXS),
    },
  },
});
